export default __webpack_public_path__ + "d87cdc4692fe580357e2fd30852acb56.svg";